module.exports = __webpack_public_path__ + "static/media/arrow_left.0b3a754a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/arrow_left.svg
// module id = 316
// module chunks = 2